const breadcrumbsHome = { name: 'Home', pathName: '/home' }
const breadcrumbsClientes = { name: 'Clientes', pathName: null, action: 'clientes' }

export default [
  {
    path: '/clientes',
    component: () => import('@/modules/clientes/views/pages/Clientes.vue'),
    children: [
      {
        path: 'segmentacao/nova/:id?',
        alias: ['segmentacao_v2/nova/:id?'],
        component: () => import('@/modules/clientes/segmentation/views/pages/AlteracaoSegmentation.vue'),
        props: {
          isNew: true,
        },
        meta: {
          breadcrumbs: [
            breadcrumbsHome,
            breadcrumbsClientes,
            {
              name: 'Segmentação',
              pathName: '/clientes/segmentacao_v2',
            },
            {
              name: 'Novo segmento',
              pathName: null,
            },
          ],
          title: 'Novo segmento',
          pagePermission: 'clientes/segmentacao',
        },
      },
      {
        path: 'segmentacao/editar/:id',
        name: 'editar-segmentacao',
        alias: ['segmentacao_v2/editar/:id'],
        component: () => import('@/modules/clientes/segmentation/views/pages/AlteracaoSegmentation.vue'),
        meta: {
          breadcrumbs: [
            breadcrumbsHome,
            {
              name: 'Clientes',
              pathName: null,
            },
            {
              name: 'Segmentação',
              pathName: '/clientes/segmentacao_v2',
            },
            {
              name: 'Editar segmentação',
              pathName: null,
            },
          ],
          title: 'Editar segmentação',
          pagePermission: 'clientes/segmentacao',
        },
      },
      {
        path: 'segmentacao/visualizar/:campaignId/:segmentId',
        name: 'visualizar-segmentacao',
        alias: ['segmentacao_v2/visualizar/:campaignId'],
        component: () => import('@/modules/clientes/segmentation/views/pages/ViewSegmentation.vue'),
        meta: {
          breadcrumbs: [
            breadcrumbsHome,
            {
              name: 'Clientes',
              pathName: null,
            },
            {
              name: 'Segmentação',
              pathName: '/clientes/segmentacao_v2',
            },
            {
              name: 'Visualizar segmentação',
              pathName: null,
            },
          ],
          title: 'Visualizar segmentação',
          pagePermission: 'clientes/segmentacao',
        },
      },
      {
        path: 'segmentacao',
        name: 'segmentacao',
        alias: ['segmentacao_v2'],
        component: () => import('@/modules/clientes/segmentation/views/pages/Segmentation.vue'),
        meta: {
          breadcrumbs: [
            breadcrumbsHome,
            {
              name: 'Clientes',
              pathName: null,
            },
            {
              name: 'Segmentação',
              pathName: '/clientes/segmentacao_v2',
            },
          ],
          title: 'Segmentação',
          pagePermission: 'clientes/segmentacao',
        },
      },
      {
        path: 'perfil-demografico',
        component: () => import('@/modules/clientes/perfil-demografico/views/pages/PerfilDemografico.vue'),
        meta: {
          breadcrumbs: [
            breadcrumbsHome,
            breadcrumbsClientes,
            {
              name: 'Perfil demográfico',
              pathName: null,
            },
          ],
          title: 'Perfil demográfico',
          pagePermission: 'clientes/perfil_demografico',
        },
      },
      {
        path: 'melhores-clientes',
        component: () => import('@/modules/clientes/melhores-clientes/views/pages/MelhoresClientes.vue'),
        meta: {
          breadcrumbs: [
            breadcrumbsHome,
            breadcrumbsClientes,
            {
              name: 'Melhores clientes',
              pathName: null,
            },
          ],
          title: 'Melhores clientes',
          pagePermission: 'clientes/melhores_clientes',
        },
      },
      {
        path: 'busca-cliente',
        component: () => import('@/components/busca-detalhes/Busca.vue'),
        props: {
          searchType: 'cliente',
        },
        meta: {
          breadcrumbs: [
            breadcrumbsHome,
            breadcrumbsClientes,
            {
              name: 'Busca de cliente',
              pathName: null,
            },
          ],
          title: 'Busca de cliente',
          pagePermission: 'clientes/busca_cliente',
        },
      },
      {
        path: 'detalhes-cliente/:id',
        component: () => import('@/modules/clientes/detalhes-cliente/views/pages/DetalhesCliente.vue'),
        meta: {
          breadcrumbs: [
            breadcrumbsHome,
            breadcrumbsClientes,
            {
              name: 'Busca de cliente',
              pathName: '/clientes/busca-cliente',
            },
            {
              name: 'Detalhes do cliente',
              pathName: null,
            },
          ],
          title: 'Detalhes do cliente',
          pagePermission: 'clientes/detalhes_cliente',
        },
      },
      {
        path: 'retencao',
        component: () => import('@/modules/clientes/retencao/views/pages/Retencao.vue'),
        meta: {
          breadcrumbs: [
            breadcrumbsHome,
            breadcrumbsClientes,
            {
              name: 'Retenção',
              pathName: null,
            },
          ],
          title: 'Retenção',
          pagePermission: 'clientes/retencao',
        },
      },
      {
        path: 'interesses',
        component: () => import('@/modules/clientes/interesses/views/pages/Index.vue'),
        meta: {
          breadcrumbs: [
            breadcrumbsHome,
            breadcrumbsClientes,
            {
              name: 'Interesses',
              pathName: null,
              action: 'clientes/interesses',
            },
          ],
          title: 'Interesses',
        },
        children: [
          {
            path: 'por-genero',
            component: () => import('@/modules/clientes/interesses/views/components/tabs/Genero.vue'),
            meta: {
              breadcrumbs: [
                breadcrumbsHome,
                breadcrumbsClientes,
                {
                  name: 'Interesses',
                  pathName: null,
                  action: 'clientes/interesses',
                },
              ],
              title: 'Interesses por gênero',
              pagePermission: 'clientes/interesses/genero',
            },
          },
          {
            path: 'por-idade',
            component: () => import('@/modules/clientes/interesses/views/components/tabs/Idade.vue'),
            meta: {
              breadcrumbs: [
                breadcrumbsHome,
                breadcrumbsClientes,
                {
                  name: 'Interesses',
                  pathName: null,
                  action: 'clientes/interesses',
                },
              ],
              title: 'Interesses por idade',
              pagePermission: 'clientes/interesses/idade',
            },
          },
          {
            path: 'pessoa-juridica',
            component: () => import('@/modules/clientes/interesses/views/components/tabs/PessoaJuridica.vue'),
            meta: {
              breadcrumbs: [
                breadcrumbsHome,
                breadcrumbsClientes,
                {
                  name: 'Interesses',
                  pathName: null,
                  action: 'clientes/interesses',
                },
              ],
              title: 'Interesses pessoa jurídica',
              pagePermission: 'clientes/interesses/pessoa_juridica',
            },
          },
        ],
      },
      {
        path: 'mapa',
        component: () => import('@/modules/clientes/mapa/views/pages/Mapa.vue'),
        meta: {
          title: 'Mapa',
          pagePermission: 'clientes/mapa',
        },
      },
      {
        path: 'gerenciamento',
        component: () => import('@/modules/clientes/gerenciamento/views/pages/Index.vue'),
        meta: {
          breadcrumbs: [
            breadcrumbsHome,
            breadcrumbsClientes,
            {
              name: 'Gerenciamento de clientes',
              pathName: null,
              action: 'clientes/gerenciamento',
            },
          ],
          title: 'Gerenciamento de clientes',
        },
        children: [
          {
            path: 'cadastros',
            component: () => import('@/modules/clientes/gerenciamento/views/components/CustomersManagementRegister.vue'),
            meta: {
              breadcrumbs: [
                breadcrumbsHome,
                breadcrumbsClientes,
                {
                  name: 'Gerenciamento de clientes',
                  pathName: null,
                  action: 'clientes/gerenciamento',
                },
              ],
              title: 'Gerenciamento de clientes',
              pagePermission: 'clientes/gerenciamento/cadastros/visualizar-cadastros',
            },
            children: [
              {
                path: 'edicao-cadastros',
                meta: {
                  pagePermission: 'clientes/gerenciamento/cadastros/edicao-cadastros',
                },
              },
              {
                path: 'edicao-pontos',
                meta: {
                  pagePermission: 'clientes/gerenciamento/cadastros/edicao-pontos',
                },
              },
            ],
          },
          {
            path: 'solicitacoes',
            component: () => import('@/modules/clientes/gerenciamento/views/components/CustomersManagementRequests.vue'),
            meta: {
              breadcrumbs: [
                breadcrumbsHome,
                breadcrumbsClientes,
                {
                  name: 'Gerenciamento de clientes',
                  pathName: null,
                  action: 'clientes/gerenciamento',
                },
              ],
              title: 'Gerenciamento de clientes',
              pagePermission: 'clientes/gerenciamento/solicitacoes',
            },
          },
        ],
      },
      {
        path: 'classificacao-rfv/:analysisId?',
        component: () => import('@/modules/clientes/rfv/views/pages/index.vue'),
        name: 'Classificação RFV',
        meta: {
          breadcrumbs: [
            breadcrumbsHome,
            breadcrumbsClientes,
            {
              name: 'Classificação RFV',
              pathName: null,
            },
          ],
          title: 'Classificação RFV',
          pagePermission: 'clientes/rfv',
        },
      },
      {
        path: 'consultar-ofertas',
        name: 'consultar-ofertas',
        component: () => import('@/modules/clientes/consultar-ofertas/views/pages/ConsultarOfertas.vue'),
        meta: {
          breadcrumbs: [
            breadcrumbsHome,
            breadcrumbsClientes,
            {
              name: 'Consultar Benefícios',
              pathName: null,
            },
          ],
          title: 'Consultar Benefícios',
          pagePermission: 'clientes/consultar-ofertas',
          allowOnlyMercapromo: true,
        },
      },
      {
        path: 'consultar-ofertas/ofertas-e-descontos',
        name: 'consultar-ofertas-descontos',
        component: () => import('@/modules/clientes/consultar-ofertas/views/pages/ConsultarOfertasDescontosForm.vue'),
        meta: {
          breadcrumbs: [
            breadcrumbsHome,
            breadcrumbsClientes,
            {
              name: 'Consultar Benefícios',
              pathName: '/clientes/consultar-ofertas',
            },
          ],
          title: 'Ofertas e Descontos',
          pagePermission: 'clientes/consultar-ofertas',
          allowOnlyMercapromo: true,
        },
      },
      {
        path: 'consultar-ofertas/ofertas-e-descontos/resultado/:c/:d/:u/:p+',
        name: 'consultar-ofertas-descontos-resultado',
        component: () => import('@/modules/clientes/consultar-ofertas/views/pages/ConsultarOfertasDescontosResultado.vue'),
        props: (route) => ({
          consumer: route.params.c,
          date: route.params.d,
          unit: route.params.u,
          products: route.params.p,
        }),
        meta: {
          breadcrumbs: [
            breadcrumbsHome,
            breadcrumbsClientes,
            {
              name: 'Consultar Benefícios',
              pathName: '/clientes/consultar-ofertas',
            },
            {
              name: 'Ofertas e Descontos',
              pathName: '/clientes/consultar-ofertas/ofertas-e-descontos',
            },
          ],
          title: 'Ofertas e Descontos Resultado',
          pagePermission: 'clientes/consultar-ofertas',
          allowOnlyMercapromo: true,
        },
      },
      {
        path: 'consultar-ofertas/cashback',
        name: 'consultar-cashback',
        component: () => import('@/modules/clientes/consultar-ofertas/views/pages/ConsultarCashbackForm.vue'),
        meta: {
          breadcrumbs: [
            breadcrumbsHome,
            breadcrumbsClientes,
            {
              name: 'Consultar Benefícios',
              pathName: '/clientes/consultar-ofertas',
            },
          ],
          title: 'Cashback',
          pagePermission: 'clientes/consultar-ofertas',
          allowOnlyMercapromo: true,
        },
      },
      {
        path: 'consultar-ofertas/cashback/resultado/:c/:sd/:ed',
        name: 'consultar-cashback-resultado',
        component: () => import('@/modules/clientes/consultar-ofertas/views/pages/ConsultarCashbackResultado.vue'),
        props: (route) => ({
          consumer: route.params.c,
          startDate: route.params.sd,
          endDate: route.params.ed,
        }),
        meta: {
          breadcrumbs: [
            breadcrumbsHome,
            breadcrumbsClientes,
            {
              name: 'Consultar Benefícios',
              pathName: '/clientes/consultar-ofertas',
            },
            {
              name: 'Cashback',
              pathName: '/clientes/consultar-ofertas/cashback',
            },
          ],
          title: 'Cashback',
          pagePermission: 'clientes/consultar-ofertas',
          allowOnlyMercapromo: true,
        },
      },
      {
        path: 'consultar-ofertas/voucher-ze',
        name: 'consultar-voucher-ze',
        component: () => import('@/modules/clientes/consultar-ofertas/views/pages/ConsultarVoucherZeForm.vue'),
        meta: {
          breadcrumbs: [
            breadcrumbsHome,
            breadcrumbsClientes,
            {
              name: 'Consultar Benefícios',
              pathName: '/clientes/consultar-ofertas',
            },
          ],
          title: 'Voucher Zé',
          pagePermission: 'clientes/consultar-ofertas',
          allowOnlyMercapromo: true,
        },
      },
      {
        path: 'consultar-ofertas/voucher-ze/resultado/:c',
        name: 'consultar-voucher-ze-resultado',
        component: () => import('@/modules/clientes/consultar-ofertas/views/pages/ConsultarVoucherZeResultado.vue'),
        props: (route) => ({
          documentNo: route.params.c,
        }),
        meta: {
          breadcrumbs: [
            breadcrumbsHome,
            breadcrumbsClientes,
            {
              name: 'Consultar Benefícios',
              pathName: '/clientes/consultar-ofertas',
            },
            {
              name: 'Voucher Zé',
              pathName: '/clientes/consultar-ofertas/voucher-ze',
            },
          ],
          title: 'Voucher Zé',
          pagePermission: 'clientes/consultar-ofertas',
          allowOnlyMercapromo: true,
        },
      },
      {
        path: 'consultar-ofertas/ativacao-cadastro',
        name: 'consultar-ativacao-cadastro',
        component: () => import('@/modules/clientes/consultar-ofertas/views/pages/ConsultarAtivacaoCadastroForm.vue'),
        meta: {
          breadcrumbs: [
            breadcrumbsHome,
            breadcrumbsClientes,
            {
              name: 'Consultar Benefícios',
              pathName: '/clientes/consultar-ofertas',
            },
          ],
          title: 'Ativação de cadastro',
          pagePermission: 'clientes/consultar-ofertas',
          allowOnlyMercapromo: true,
        },
      },
      {
        path: 'consultar-ofertas/ativacao-cadastro/resultado/:c',
        name: 'consultar-ativacao-cadastro-resultado',
        component: () => import('@/modules/clientes/consultar-ofertas/views/pages/ConsultarAtivacaoCadastroResultado.vue'),
        props: (route) => ({
          consumer: route.params.c,
        }),
        meta: {
          breadcrumbs: [
            breadcrumbsHome,
            breadcrumbsClientes,
            {
              name: 'Consultar Benefícios',
              pathName: '/clientes/consultar-ofertas',
            },
            {
              name: 'Ativação de cadastro',
              pathName: '/clientes/consultar-ofertas/ativacao-cadastro',
            },
          ],
          title: 'Ativação de cadastro',
          pagePermission: 'clientes/consultar-ofertas',
        },
      },
      {
        path: 'consultar-ofertas/pontos',
        name: 'consultar-pontos',
        component: () => import('@/modules/clientes/consultar-ofertas/views/pages/ConsultarPontosForm.vue'),
        meta: {
          breadcrumbs: [
            breadcrumbsHome,
            breadcrumbsClientes,
            {
              name: 'Consultar Benefícios',
              pathName: '/clientes/consultar-ofertas',
            },
          ],
          title: 'Pontos',
          pagePermission: 'clientes/consultar-ofertas',
          allowOnlyMercapromo: true,
        },
      },
      {
        path: 'consultar-ofertas/pontos/resultado/:c/:v?',
        name: 'consultar-pontos-resultado',
        component: () => import('@/modules/clientes/consultar-ofertas/views/pages/ConsultarPontosResultado.vue'),
        props: (route) => ({
          consumer: route.params.c,
          activeVoucher: route.params.v || null,
        }),
        meta: {
          breadcrumbs: [
            breadcrumbsHome,
            breadcrumbsClientes,
            {
              name: 'Consultar Benefícios',
              pathName: '/clientes/consultar-ofertas',
            },
            {
              name: 'Pontos',
              pathName: '/clientes/consultar-ofertas/pontos',
            },
          ],
          title: 'Pontos',
          pagePermission: 'clientes/consultar-ofertas',
          allowOnlyMercapromo: true,
        },
      },
    ],
  },
]
